import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as GroupsActions, Selectors as GroupsSelectors } from 'store/ducks/groups';

import { Form, Loading } from 'components';

class GroupForm extends Component {
  state = {
    data: this.props.data,
  };

  constructor(props) {
    super(props);

    const { getGroupsRolesRequest } = this.props;

    this.handleSearchRoles = debounce(getGroupsRolesRequest, 300);
  }

  componentDidMount() {
    const { getGroupsRolesRequest } = this.props;
    getGroupsRolesRequest();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleFindRoles = value => {
    this.handleSearchRoles(value);
  };

  handleToggleScore = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, score: !data.score } });
  };

  handleChangeInput = e => {
    const { value, name } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleSelectRoles = value => {
    const { data } = this.state;

    this.setState({
      data: { ...data, group_roles_attributes: value },
    });
  };

  handleToggleExtra = name => {
    const { data } = this.state;

    this.setState({ data: { ...data, extra_data: { ...data.extra_data, [name]: !data.extra_data[name] } } });
  };

  render() {
    const { data } = this.state;
    const { roles, errors, saving, onSubmit } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Grupos</h3>

        <Form.Field>
          <Form.Label>Nome</Form.Label>
          <Form.Input
            name="title"
            placeholder="Nome"
            value={data.title}
            errors={errors.title}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Alias</Form.Label>
          <Form.Input
            name="alias"
            placeholder="Alias"
            value={data.alias}
            errors={errors.alias}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.Input
            name="description"
            placeholder="Descrição"
            value={data.description}
            errors={errors.description}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Permissões</Form.Label>
          <Form.Select
            isMulti
            placeholder="Permissões"
            noOptionsMessage={() => 'Procurar permissões'}
            options={roles.data}
            value={data.group_roles_attributes}
            onChange={this.handleSelectRoles}
            onInputChange={this.handleFindRoles}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Bloquear Lojas</Form.Label>
          <Form.Checkbox
            name="lock_ldap_store_place"
            checked={data.extra_data.lock_ldap_store_place}
            onChange={() => this.handleToggleExtra('lock_ldap_store_place')}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Bloquear Feed</Form.Label>
          <Form.Checkbox
            name="lock_ldap_feed_local"
            checked={data.extra_data.lock_ldap_feed_local}
            onChange={() => this.handleToggleExtra('lock_ldap_feed_local')}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Bloquear Canais</Form.Label>
          <Form.Checkbox
            name="lock_ldap_store_channel"
            checked={data.extra_data.lock_ldap_store_channel}
            onChange={() => this.handleToggleExtra('lock_ldap_store_channel')}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/configs/groups" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button className="button-save" onClick={onSubmit} disabled={saving}>
            {saving ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

const mapState = state => ({
  roles: {
    ...state.groups.roles,
    data: GroupsSelectors.roles(state.groups.roles.data),
  },
});

const mapActions = dispatch => bindActionCreators(GroupsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(GroupForm);
